export default function createVariables({ restaurantId }) {
    const variables = {
        id: restaurantId,
    };

    return variables;
}
